var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('dashboard-core-app-bar'),(_vm.appDrawerAccess.size > 1)?_c('dashboard-core-drawer',{attrs:{"access":_vm.appDrawerAccess}}):_vm._e(),_c('dashboard-core-view'),_c('dashboard-core-settings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }